import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, TextField} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {arrays, forms} from "@atttomyx/shared-utils";
import {roles} from "@atttomyx/shared-constants";

const RESTRICTED_ROLES = [
    roles.SUPER,
    roles.ADMIN,
    roles.USER,
    roles.ROBOT,
    roles.GUEST,
];

const AddAppRoleDialog = (props) => {
    const { onCancel, onAdd } = props;
    const [ role, setRole ] = useState(null);

    const submitForm = () => {
        onAdd(role);
    };

    return <Dialog
        open={true}
        aria-labelledby="add-app-role-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Role
        </ClosableDialogTitle>
        <DialogContent className="add-app-role-dialog">
            <div className="field">
                <TextField
                    required={true}
                    label="Custom"
                    type="text"
                    value={forms.sanitizeValue(role)}
                    onChange={(event) => setRole(event.target.value)}
                />
            </div>
        </DialogContent>
        <DialogActions>
            <Button
                color="primary"
                disabled={!role || arrays.contains(RESTRICTED_ROLES, role) || !role.startsWith("ROLE_")}
                onClick={submitForm}
            >
                Add
            </Button>
        </DialogActions>
    </Dialog>
}

export default AddAppRoleDialog;
